var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 122,
    viewBox: "0 0 188 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 73,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3077 44.4372C59.3077 59.55 48.0974 70.2187 36.1538 70.2187C24.2103 70.2187 13 59.55 13 44.4372C13 29.3244 24.2103 18.6558 36.1538 18.6558C48.0974 18.6558 59.3077 29.3244 59.3077 44.4372Z",
    stroke: "#004225",
    strokeWidth: 26
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.4678,
    y: 3.02637,
    width: 44.6421,
    height: 80.1922,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 25,
    width: 73,
    height: 79
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.692 64.6357C128.692 79.7485 139.903 90.4172 151.846 90.4172C163.79 90.4172 175 79.7485 175 64.6357C175 49.5229 163.79 38.8542 151.846 38.8542C139.903 38.8542 128.692 49.5229 128.692 64.6357Z",
    stroke: "#004225",
    strokeWidth: 26
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24_46)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.6421,
    height: 80.1922,
    transform: "matrix(-1 0 0 1 151.532 23.2249)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3764 0H122C122 0 103.85 23.9509 103.138 61.7485C102.426 99.546 122 122 122 122H96.3764C96.3764 122 79.65 99.546 80.0056 61.7485C80.3612 23.9509 96.3764 0 96.3764 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo11);
export default __webpack_public_path__ + "static/media/Logo1 (1).6a9950968aa985a4b3ae5ac0c1346c1b.svg";
export { ForwardRef as ReactComponent };